module.exports = __webpack_public_path__ + "img/bghe6.38c289fe.png";